import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { DialogAddRows } from './dilog/add-rows.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from './../shared.service';
import { Subscription } from 'rxjs';
import notify from 'devextreme/ui/notify';

@Component({
  standalone: false,
  selector: 'cx-form-grid',
  templateUrl: './form-grid.component.html',
  styleUrls: ['./form-grid.component.scss']
})
export class FormGridComponent implements OnInit, OnChanges, OnDestroy {
  requestForm: FormGroup;
  @Input() dataSource: any;
  @Input() data: any;
  @Output() optSelected: EventEmitter<any> = new EventEmitter();
  subscription: Subscription;
  loadingIndicator: boolean;
  showGenerateBtn: boolean;
  cxList: any;
  items: any;
  isEdit: boolean;
  cxHeader: any;
  tempcxTypeDetail: any;
  total: number;
  popupTarget: any;
  actionSheetVisible: boolean;
  userRemarks: any;
  showWt: any;
  deletedBarcodes: any[] = [];
  private originalIdsByCode: Map<string, { vendorItemCatalogId: number; vendorItemCatalogDetailId: number } > = new Map();
  // DevExtreme grid state derived from FormArray
  gridData: any[] = [];
  gridColumns: any[] = [];
  // tslint:disable-next-line: max-line-length
  constructor(private sharedService: SharedService, public dialog: MatDialog) {}

  ngOnInit() {
    this.total = 0;
    this.showGenerateBtn = false;
    // this.cxHeader = [];
    
    // INIT FORM
    

    // SUBSRIPTION IF DROPWOWN CHANGE
    // this.subscription = this.sharedService.getData().subscribe(dataSource => {
    //    this.dataSource = [];
    //    this.requestForm.removeControl('sections');
    //    this.requestForm.addControl('sections', new FormArray([]));
    //    console.log(this.requestForm.value);
    //    this.dataSource = dataSource;
    //    this.addSection(dataSource);
    //   });

      this.getAllCxTypes();
  }

  // Build grid columns (uses cxList and showWt)
  private prepareGridColumns() {
    const cols: any[] = [
      {
        dataField: '_index',
        caption: 'S#.',
        width: 60,
        allowEditing: false,
        calculateCellValue: (row: any) =>
          typeof row?._index === 'number' ? row._index + 1 : ''
      },
      {
        dataField: 'cxtypeId',
        caption: 'CX Type',
        width: 140,
        lookup: this.cxList ? { dataSource: this.cxList, valueExpr: 'cxtypeId', displayExpr: 'cxtypeName' } : undefined
      },
      { 
        dataField: 'vendorItemCode', caption: 'Bar Code', dataType: 'string', width: 180,
        validationRules: [{
          type: 'custom',
          reevaluate: true,
          message: 'Duplicate barcode found in grid.',
          validationCallback: (e: any) => {
            const val = (e?.value ?? '').toString().trim();
            if (!val) return true;
            const currentIdx = (e?.data?._index ?? -1);
            let count = 0;
            for (const r of (this.gridData || [])) {
              if (((r?.vendorItemCode ?? '').toString().trim()) === val) {
                if (typeof r?._index === 'number' && r._index === currentIdx) continue;
                count++;
                if (count > 0) return false;
              }
            }
            return true;
          }
        }]
      },
      { dataField: 'cx', caption: 'CX', dataType: 'number', width: 90 },
      { dataField: 'tc', caption: 'TC', dataType: 'number', width: 90 },
      { dataField: 'cc', caption: 'CC', dataType: 'number', width: 90 },
      { dataField: 'ct', caption: 'CT', dataType: 'number', width: 90 },
      { dataField: 'et', caption: 'ET', dataType: 'number', width: 90 },
      { dataField: 'add', caption: 'ADD', dataType: 'number', width: 90 },
    ];
    if (this.showWt) cols.push({ dataField: 'wt', caption: 'WT', dataType: 'number', width: 90 });
    cols.push({ dataField: 'remarks', caption: 'Remarks', dataType: 'string', width: 220 });
    cols.push({ type: 'buttons', width: 70, buttons: ['delete'] });
    this.gridColumns = cols;
  }

  // Rebuild grid data from FormArray
  private rebuildGridData() {
    const arr = this.sectionsArray?.at(0)?.get('cxTypeDetail') as FormArray;
    const rows = (arr?.controls || []).map((ctrl, i) => ({ _index: i, ...(ctrl.value || {}) }));
    this.gridData = rows;
  }

  getInitForm() {
    this.requestForm = new FormGroup({
      sections: new FormArray([])
    });
  }
  /**
   * @name ngOnChanges
   * @desc Fires when change in input properties are detected
   * @return void
   */
  ngOnChanges (changes: SimpleChanges) {
    this.dataSource = [];
    this.getInitForm();
    if (Object.keys(changes.dataSource.currentValue).length > 0 ) {
      this.addSection(changes.dataSource.currentValue);
      this.tempcxTypeDetail = changes.dataSource.currentValue.cxTypeDetail;
      if (changes.dataSource.currentValue.showWt) {
        this.showWt = true;
            this.cxHeader = [
              {
                name: 'CX Type'
              },
              {
                name: 'Bar Code'
              },
              {
                name: 'CX'
              },
              {
                name: 'TC'
              },
              {
                name: 'CC'
              },
              {
                name: 'CT'
              },
              {
                name: 'ET'
              },
              {
                name: 'ADD'
              },
              {
                name: 'WT'
                // visible itemTypeMasterId == 4
              },
              {
                name: 'Remarks'
              }
            ];
      } else {
        this.showWt = false;
        this.cxHeader = [
          {
            name: 'CX Type'
          },
          {
            name: 'Bar Code'
          },
          {
            name: 'CX'
          },
          {
            name: 'TC'
          },
          {
            name: 'CC'
          },
          {
            name: 'CT'
          },
          {
            name: 'ET'
          },
          {
            name: 'ADD'
          },
          {
            name: 'Remarks'
          }
        ];
      }
      if (changes.dataSource.currentValue.cxTypeDetail && changes.dataSource.currentValue.cxTypeDetail.length) {
        try {
          // build original code -> ids map (edit mode identity preservation)
          this.originalIdsByCode.clear();
          const list = changes.dataSource.currentValue.cxTypeDetail || [];
          for (const row of list) {
            const code = (row?.vendorItemCode ?? '').toString().trim();
            if (!code) continue;
            this.originalIdsByCode.set(code, {
              vendorItemCatalogId: Number(row.vendorItemCatalogId || 0),
              vendorItemCatalogDetailId: Number(row.vendorItemCatalogDetailId || 0)
            });
          }
        } catch {}
        for (
          let i = 0;
          i < changes.dataSource.currentValue.cxTypeDetail.length;
          i++
        ) {
          this.createCxTypeDetail(
            changes.dataSource.currentValue.cxTypeDetail[i]
          );
        }
      } 
      // else {
      //   const option = {
      //     width: 300,
      //     displayTime: 3000,
      //     message: 'Cx Details not found...',
      //     type: 'error'
      //     };
      //     notify(option);
      // }
      if(changes.dataSource.currentValue.isEdit) {
        // this.generateGrid(changes.dataSource.currentValue.childern[0].min, changes.dataSource.currentValue.childern[0].max);
        this.isEdit = true;
        // ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').disable();
        // ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').disable();
       
      }
      // Update grid columns and data after we have showWt/cxTypeDetail
      this.prepareGridColumns();
      this.rebuildGridData();
    }
    }

  /**
   * @name addSection
   * @param data 
   * @returns void
   * @description create section array
   */
  addSection(data?: any): void {
    if (data) {
    // data.forEach((controls: any) => {
    if (data.active) {
        console.log(data);
        this.showGenerateBtn = data.generateBtn;
        this.sectionsArray.push(this.createSection(data));
        // const sectionsList = this.requestForm.get('sections') as FormArray;
        // sectionsList.push(this.createSection(data));
      }
      // });
    }
 }

 /**
  * @name createSection
  * @param data 
  * @return FormGroup
  * @description section controls
  */
 createSection(data?: any): FormGroup {
    return new FormGroup({
      condition: new FormControl(data ? data.condition : '', []),
      active: new FormControl(data ? data.active : false, []),
      childern: new FormArray(this.addChildern(data.childern)),
      cxTypeDetail: new FormArray([])
   });
}

/**
 * @name addChildern
 * @param data
 * @returns childern array 
 */
addChildern(data?: any) {
  const formArray = [];
  data.forEach( child => {
    formArray.push(this.createChild(child));
  });
  return formArray;
}

/**
 * @name createChild
 * @param child 
 * @return  childer controls
 * @deprecated child formcontrols
 */
createChild(child?): FormGroup {
  return new FormGroup({
    name: new FormControl(child ? child.name : '', []),
    min: new FormControl(child ? child.min : '', [Validators.required]),
    max: new FormControl(child ? child.max : '', [Validators.required]),
  });
}

/**
 * @name sectionsArray
 * @returns section array controls
 */
  get sectionsArray() {
    return this.requestForm.get('sections') as FormArray;
  }

  /**
 * @name getChildern
 * @param form section item index
 * @returns childern array controls
 */
   getChildern(form) {
     return form.controls.childern.controls;
  }

    /**
 * @name getCxTypeDetail
 * @param form section item index
 * @returns cxTyeDetail array controls
 */
  getCxTypeDetail(form) {
    return form.controls.cxTypeDetail.controls;
  }

  /**
   * @name createCxTypeDetail
   * @require add cxtypedetail array
   */
  createCxTypeDetail(data?: any) {
    const item = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
    item.push(this.addCxTypeDetail(data));
    
  }

   /**
  * @name addCxTypeDetail
  * @param data 
  * @return FormGroup
  * @description cxtypedetail controls
  */
  addCxTypeDetail(data?: any): FormGroup {
    // best-effort resolve cxtypeId from different shapes
    let resolvedCxTypeId = 3;
    if (data && (data.cxtypeId || data.cxtypeId === 0)) {
      resolvedCxTypeId = data.cxtypeId;
    } else if (data && (data.cxTypeId || data.cxTypeId === 0)) {
      resolvedCxTypeId = data.cxTypeId;
    } else if (data && data.cxtypeName && Array.isArray(this.cxList)) {
      const found = this.cxList.find((x: any) => x?.cxtypeName === data.cxtypeName);
      if (found) resolvedCxTypeId = found.cxtypeId;
    }
    return new FormGroup({
      cx: new FormControl((data && (data.cx || data.cx === 0)) ? data.cx : '', []),
      cxtypeId: new FormControl(resolvedCxTypeId, []),
      vendorItemCode: new FormControl(data ? (data.vendorItemCode ?? '') : '', []),
      cc: new FormControl((data && (data.cc || data.cc === 0)) ? data.cc : '', []),
      add: new FormControl((data && (data.addf || data.addf === 0)) ? data.addf : '', []),
      // axis: new FormControl(data ? data.axis : '', []),
      // cyl: new FormControl(data ? data.cyl : '', []),
      ct: new FormControl((data && (data.ct || data.ct === 0)) ? data.ct : '', []),
      et: new FormControl((data && (data.et || data.et === 0)) ? data.et : '', []),
      tc: new FormControl((data && (data.tc || data.tc === 0)) ? data.tc : '', []),
      wt: new FormControl((data && (data.wt || data.wt === 0)) ? data.wt : '', []),
      remarks: new FormControl(data ? (data.remarks ?? '') : '', []),
      vendorItemCatalogId: new FormControl(data ? (data.vendorItemCatalogId ?? 0) : 0, []),
    });
  }
 
  /**
   * @name saveStockRequest
   * @param {FormGroup} requestForm 
   * @returns payload form cxtypedetail
   */
  saveStockRequest(requestForm: FormGroup) {
    if (requestForm.invalid) {
      return false;
    }
    const payload = requestForm.value;
    // Normalize CX detail so parent always receives usable rows
    try {
      const arr = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
      const normalizedRaw = (arr?.value || []).map((item: any) => ({
        ...item,
        vendorItemCode: (item?.vendorItemCode ?? '').toString().trim(),
        cxtypeId: (item?.cxtypeId || item?.cxtypeId === 0) ? Number(item.cxtypeId) : 3,
        cx: (item?.cx || item?.cx === 0) ? Number(item.cx) : 0,
        tc: (item?.tc || item?.tc === 0) ? Number(item.tc) : 0,
        cc: (item?.cc || item?.cc === 0) ? Number(item.cc) : 0,
        ct: (item?.ct || item?.ct === 0) ? Number(item.ct) : 0,
        et: (item?.et || item?.et === 0) ? Number(item.et) : 0,
        wt: (item?.wt || item?.wt === 0) ? Number(item.wt) : 0,
        add: (item?.add || item?.add === 0) ? Number(item.add) : (item?.addf || item?.addf === 0) ? Number(item.addf) : 0,
        // Always send as active rows from grid
        active: true,
        // Retain identity by matching code from original edit payload
        vendorItemCatalogId: this.originalIdsByCode.get((item?.vendorItemCode ?? '').toString().trim())?.vendorItemCatalogId || Number(item?.vendorItemCatalogId || 0),
        vendorItemCatalogDetailId: this.originalIdsByCode.get((item?.vendorItemCode ?? '').toString().trim())?.vendorItemCatalogDetailId || Number(item?.vendorItemCatalogDetailId || 0),
      }));
      // Remove empty rows and check duplicates
      const normalized = (normalizedRaw || []).filter(x => x.vendorItemCode !== '');
      const dupCodes = this.collectDuplicateCodes(normalized.map(x => x.vendorItemCode));
      if (dupCodes.length) {
        notify({ width: 420, displayTime: 3500, type: 'error', message: `Duplicate barcode${dupCodes.length > 1 ? 's' : ''}: ${dupCodes.join(', ')}` });
        return false;
      }
      if (Array.isArray(payload?.sections) && payload.sections[0]) {
        payload.sections[0].cxTypeDetail = normalized;
      }
    } catch { }

    // Do not send any inactive rows from child; backend handles deletions.
    payload.rangeStockListPayload = [];
    this.optSelected.emit(payload);
  }

  
  //  saveStockRequest(requestForm: FormGroup) {
  //   if (requestForm.invalid) return false;
  //   const payload = requestForm.value;
  //   payload.rangeStockListPayload = this.getPayload();
  //   this.optSelected.emit(payload);
  // }






  /**
   * @name clearField
   * @return void
   */
  clearField(): void {
    const item = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
    while (item.length !== 0) {
      item.removeAt(0);
    }
    // const item = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
    // while (item.length !== 0) {
    //   item.removeAt(0);
    // }
    // const child = (this.requestForm.get('sections') as FormArray).at(0).get('childern') as FormArray;
    // while (child.length !== 0) {
    //   child.removeAt(0);
    // }
    ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').setValue('');
    ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue('');
    // ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').setValue('');
    // ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue('');
   
}
/**
 * @description validateSubmitBtn
 * @returns bool
 */
get validateSubmitBtn() {
 let val = false;
   const item = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
    item.controls.forEach((element) => {
    // console.log(element.value);
    if (element.value.vendorItemCode || element.value.add || element.value.cc
       || element.value.ct || element.value.cx || element.value.et || element.value.tc || element.value.wt) {
       val = true;
    }
   });
   return val;
}
/**
 * @description destroy component
 */
  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
   // this.subscription.unsubscribe();
}

/**
 * @name generateGrid
 * @param {number} min 
 * @param {number} max 
 * @return grid 
 */
  generateGrid(min: number, max: number) {
    for (let i = min; max >= i ; i++) {
      this.createCxTypeDetail(this.tempcxTypeDetail ? this.tempcxTypeDetail[i] : '');
      //this.validateSubmitBtn;
    }
    this.rebuildGridData();
  }

/**
   * @name getAllCxTypes
   * @description item cx type
   * @method GET
   * @returns Promise
   */
  getAllCxTypes() {
    this.loadingIndicator = true;
    this.sharedService.getAllCxTypes()
        .then((response) => {
          if (response.data.completed) {
            this.cxList = response.data.payload;
            this.loadingIndicator = false;
            this.prepareGridColumns();
          }
        })
        .catch((err) => {
          this.loadingIndicator = false;
          console.log('err ', err);
        });
  }
  /**
   * @name addRows 
   * @return number of rows
   * @description modal popup
   */
  addRows() {
    const dialogRef = this.dialog.open(DialogAddRows, {
      width: '250px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      if (result.rows) {
        for (let i = 0; i < parseInt(result.rows); i++) {
            this.createCxTypeDetail();
            this.updatedMaxVal('increment');
        }
        this.rebuildGridData();
     }
    });
  }

  /**
   * @name incrementMaxVal
   * @returns updated max value
   */
  updatedMaxVal(label: string) {
    const val  = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
    if (label === 'increment') {
      return  ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue(parseInt(val) + 1);
    }
    if (label === 'decrement') {
      return  ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue(parseInt(val) - 1);
    }
  }

  /**
   * @name removeIndex
   * @param index 
   * @return void
   * @description removing row index
   */
  // removeIndex(index) {
  //   const item = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
  //   item.removeAt(index);
  //   this.updatedMaxVal('decrement');
  //   // ((this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray).removeAt(index);
  // }
  removeIndex(index: number) {
    const item = this.sectionsArray.at(0).get('cxTypeDetail') as FormArray;
    // No need to push deleted rows; backend will handle via delta of active rows
    item.removeAt(index);
    this.updatedMaxVal('decrement');
    this.rebuildGridData();
  }
    getPayload() { return []; }


   /**
   * @name getTotal
   * @param {Array} list
   * @param {key} string
   * @returns total
   */
  getTotal() {
    let tot = 0;
     const item = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
    item.value.forEach(item => {
      let val = parseInt(item.cx ? item.cx : 0) + parseInt(item.cc ? item.cc : 0) + parseInt(item.add ? item.add : 0) + parseInt(item.ct ? item.ct : 0)
       + parseInt(item.et ? item.et : 0) + parseInt(item.tc ? item.tc : 0) + parseInt(item.wt ? item.wt : 0);
       tot += val;
    });
    this.total =  tot;
}
/**
   * @name showRemarks
   * @param {FormGroup} section
   * @param {number} index
   * @returns void
   */
  showRemarks(section: FormGroup, index: number) {
    this.userRemarks = null;
    this.popupTarget = '#comment-' + index;
    this.actionSheetVisible = true;
    this.userRemarks = section.value.cxTypeDetail[index].remarks;
  }

  // DevExtreme grid events
  onGridSaving(e: any) {
    const arr = this.sectionsArray?.at(0)?.get('cxTypeDetail') as FormArray;
    for (const ch of (e.changes || [])) {
      const key = ch.key; // _index
      const data = ch.data || {};
      if (typeof key === 'number' && arr?.at(key)) {
        const grp = arr.at(key) as FormGroup;
        Object.keys(data).forEach((df) => {
          if (grp.get(df)) grp.get(df).setValue(data[df]);
        });
      }
    }
    this.rebuildGridData();
    this.getTotal();
  }

  onGridRowRemoving(e: any) {
    const idx = typeof e.key === 'number' ? e.key : e.data?._index;
    if (typeof idx === 'number') {
      this.removeIndex(idx);
      e.cancel = true;
    }
  }

   onGridCellValueChanged(e: any) {
    const idx = typeof e.key === 'number' ? e.key : e.data?._index;
    if (typeof idx !== 'number') return;
    const arr = this.sectionsArray?.at(0)?.get('cxTypeDetail') as FormArray;
    const ctrl = (arr?.at(idx) as FormGroup);
    if (!ctrl?.get(e.column?.dataField)) return;
    ctrl.get(e.column.dataField).setValue(e.value);
    try { this.gridData[idx][e.column.dataField] = e.value; } catch { }
    this.getTotal();
    if (e.column?.dataField === 'remarks') {
      this.userRemarks = e.value;
    }
    if (e.column?.dataField === 'vendorItemCode') {
      const code = (e?.value ?? '').toString().trim();
      if (!code) return;
      const dup = this.findDuplicateCodes(code, idx);
      if (dup) {
        // revert and notify
        ctrl.get('vendorItemCode').setValue('');
        try { this.gridData[idx]['vendorItemCode'] = ''; } catch { }
        notify({ width: 360, displayTime: 3000, type: 'error', message: `Duplicate barcode: ${code}` });
      }
    }
  }



  onGridEditorPreparing(e: any) {
    if (e.parentType !== 'dataRow') return;
    if (e.dataField === 'remarks') {
      e.editorOptions = {
        ...(e.editorOptions || {}),
        onFocusIn: () => {
          this.popupTarget = e.editorElement;
          this.userRemarks = e?.row?.data?.remarks;
          this.actionSheetVisible = true;
        }
      };
    }
  }

  // Helpers
  private findDuplicateCodes(code: string, excludeIndex?: number): boolean {
    const val = (code ?? '').toString().trim();
    if (!val) return false;
    let seen = 0;
    for (const r of (this.gridData || [])) {
      const c = (r?.vendorItemCode ?? '').toString().trim();
      if (!c) continue;
      if (typeof excludeIndex === 'number' && r?._index === excludeIndex) continue;
      if (c === val) {
        seen++;
        if (seen > 0) return true;
      }
    }
    return false;
  }

  private collectDuplicateCodes(codes: string[]): string[] {
    const seen = new Map<string, number>();
    const dups: string[] = [];
    for (const c of codes || []) {
      const v = (c ?? '').toString().trim();
      if (!v) continue;
      const n = (seen.get(v) || 0) + 1;
      seen.set(v, n);
      if (n === 2) dups.push(v);
    }
    return dups;
  }
}
